import Vue from 'vue';
import VDataTable from 'vuetify';
import VueToasted from 'vue-toasted';
import DatetimePicker from 'vuetify-datetime-picker';
import VCalendar from 'v-calendar';
import VueYoutube from 'vue-youtube';
import PortalVue from 'portal-vue';
import VApiDatatable from 'v-api-datatable';
import VueInputMask from 'vue-the-mask';
import VDatetimeField from 'v-datetime-field';
import TextareaAutosize from 'vue-textarea-autosize';

import VueFlicking from '@egjs/vue-flicking';
import ApiPlugin from '@/plugins/api';
import vuetify from '@/plugins/vuetify';
import RHandler, { rHandler } from '@/plugins/response-handler';
import Dateprint from '@/plugins/dateprint';
import User from '@/plugins/user';
import Modals from '@/plugins/modals';
import AppLoader from '@/plugins/app-loader';
import AppChat from '@/plugins/app-chat';
import i18n from '@/plugins/i18n';

import App from './App.vue';
import router from './router';
import store from './store';
import '@egjs/vue-flicking/dist/flicking.css';

import '@/plugins/vee-validate';
import '@/plugins/constants';
import '@/components/Global';
import '@/filters';

Vue.use(VueFlicking);
Vue.use(TextareaAutosize);
Vue.use(VDataTable);
Vue.use(PortalVue);
Vue.use(DatetimePicker);
Vue.use(VueYoutube);
Vue.use(User, store);
Vue.use(VueInputMask);
Vue.use(VDatetimeField);
Vue.use(Modals);
Vue.use(AppLoader, store);
Vue.use(AppChat, store);

Vue.use(VApiDatatable, {
  preSave: (method, { args, data, obs }) => (
    rHandler(
      method(...args, data),
      (resp) => (resp),
      (err) => (new Error(err)),
      obs,
    )),
});

Vue.config.productionTip = false;

Vue.use(VueToasted, {
  iconPack: 'mdi',
  duration: 3000,
  position: 'bottom-right',
});

Vue.use(VCalendar, {
  componentPrefix: 'vc',
});

Vue.use(ApiPlugin);
Vue.use(RHandler);
Vue.use(Dateprint);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app');

// TODO: Fix mutate props

// Vue.directive('server-items', {
//   async inserted(el, binding, vnode) {
//     const response = await binding.value();

//     vnode.componentInstance.items = response.data.data;
//     const { itemText } = vnode.componentOptions.propsData;
//     const { itemValue } = vnode.componentOptions.propsData;
//     vnode.componentInstance.itemText = itemText || 'name';
//     vnode.componentInstance.itemValue = itemValue || 'id';
//   },
// });
